"use client";

import * as React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const projects = [{
  id: 1,
  title: "Bespoke Marble Installation",
  category: "Bathroom Renovation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/tiling_portfolio_porcelain.png",
  location: "Chelsea, London"
}, {
  id: 2,
  title: "Minimalist Wet Room",
  category: "Wet Room Specialist",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/tiling_portfolio_wetroom.png",
  location: "Kensington, London"
}, {
  id: 3,
  title: "Precision Mitred Kitchen",
  category: "Wall & Floor Tiling",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/tiling_portfolio_precision.png",
  location: "Richmond, London"
}, {
  id: 4,
  title: "Victorian Hallway Restoration",
  category: "Heritage Tiling",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/tiling_portfolio_victorian.png",
  location: "Westminster, London"
}, {
  id: 5,
  title: "Large Format Porcelain",
  category: "Floor Tiling",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/tiling_portfolio_marble.png",
  location: "Mayfair, London"
}, {
  id: 6,
  title: "Luxury Spa Bathroom",
  category: "Full Refurbishment",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/tiling_portfolio_slate.png",
  location: "Canary Wharf, London"
}];
export default function Portfolio() {
  return <section data-section-id="43075" id="projectgallery" className="bg-background py-40 !text-[hsl(0,0%,0%)]">
      <div className="container ml-0 mr-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-start text-left md:mb-24">
          <h2 className="text-primary mb-4 text-sm font-medium tracking-widest uppercase">
            Our Portfolio of Excellence
          </h2>
          <h3 className="font-serif text-4xl font-medium !text-[hsl(0,0%,0%)] md:text-5xl lg:text-6xl">
            Recent Projects
          </h3>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed !text-[hsl(0,0%,0%)]">
            Discover our commitment to precision and luxury through a selection of high-end tiling and full bathroom transformations across London.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, i) => <div key={project.id} data-index={i} className="group">
              <Link to="#" className="block h-full">
                <Card className="flex flex-col gap-6 py-6 pt-0 bg-card border-border h-full overflow-hidden rounded-[2px] border shadow-md transition-shadow duration-300 !text-[hsl(0,0%,0%)] hover:shadow-xl">
                  <div className="relative overflow-hidden">
                    <AspectRatio ratio={4 / 5}>
                      <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                    </AspectRatio>
                    <div className="bg-primary/90 absolute top-4 right-4 flex size-10 items-center justify-center rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      <ArrowUpRight className="text-primary-foreground size-5" />
                    </div>
                  </div>
                  <CardHeader className="pb-2">
                    <div className="flex items-center justify-between">
                      <CardDescription className="text-primary text-xs font-medium uppercase tracking-wider">
                        {project.category}
                      </CardDescription>
                      <span className="text-muted-foreground text-xs">
                        {project.location}
                      </span>
                    </div>
                    <CardTitle className="font-serif text-2xl font-medium !text-[hsl(0,0%,0%)]">
                      {project.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="line-clamp-2 text-sm !text-[hsl(0,0%,0%)]">
                      A premium installation featuring precision 45-degree mitred edges and high-grade epoxy grout finishing for a seamless look.
                    </p>
                  </CardContent>
                </Card>
              </Link>
            </div>)}
        </div>

        <div className="mt-20 flex justify-start">
          <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground min-w-[200px] rounded-[2px] transition-all duration-300">
            <Link to="#">View All Projects</Link>
          </Button>
        </div>
      </div>
    </section>;
}